import React from 'react';
import { Card } from 'primereact/card';
import { Chart } from 'primereact/chart';

const StatusDistributionChart = ({ data }) => {
    if (!data || !data.statuses || data.statuses.length === 0) {
        return (
            <Card className="chart-card">
                <div className="chart-header">
                    <h3>Status Distribution</h3>
                    <div className="chart-subtitle">No data available</div>
                </div>
            </Card>
        );
    }

    const statuses = data.statuses || [];
    
    const chartData = {
        labels: statuses.map(item => item.status),
        datasets: [
            {
                data: statuses.map(item => item.count || 0),
                backgroundColor: statuses.map(item => item.color || '#CCCCCC'),
                hoverBackgroundColor: statuses.map(item => item.color || '#CCCCCC')
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    usePointStyle: true,
                    padding: 20
                }
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        const label = context.label || '';
                        const value = context.parsed || 0;
                        const total = context.dataset.data.reduce((a, b) => a + b, 0);
                        const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
                        return `${label}: ${value} (${percentage}%)`;
                    }
                }
            }
        }
    };

    return (
        <Card className="chart-card">
            <div className="chart-header">
                <h3>Status Distribution</h3>
                <div className="chart-subtitle">Total Loans: {data.totalLoans || 0}</div>
            </div>
            <div className="chart-container">
                <Chart type="doughnut" data={chartData} options={options} />
            </div>
        </Card>
    );
};

export default StatusDistributionChart;
